import React from 'react'
import { PermissionType } from '@/common/types'
import useQueryGetOperatorMe from '@/modules/operator/api/hooks/useQueryGetMe'
import { Navigate } from 'react-router-dom'
import Spinner from '../Spinner'

interface withUserPermissionProps {
	permissionType: PermissionType
	permissionKey: string[]
}

const withUserPermission =
	(
		Component: React.ComponentType,
		{ permissionType, permissionKey }: withUserPermissionProps,
	) =>
	// eslint-disable-next-line react/display-name
	() => {
		const { data: user, isLoading, error } = useQueryGetOperatorMe()

		if (isLoading) {
			return <Spinner />
		}

		if (error || !user) {
			return <Navigate to="/login" />
		}

		if (
			(permissionType === PermissionType.Read &&
				!user.userGroup.readPermission.some((permission) =>
					permissionKey.includes(permission),
				) &&
				!user.userGroup.writePermission.some((permission) =>
					permissionKey.includes(permission),
				)) ||
			(permissionType === PermissionType.Write &&
				!user.userGroup.writePermission.some((permission) =>
					permissionKey.includes(permission),
				))
		) {
			return <Navigate to="/" />
		}

		return <Component />
	}

export default withUserPermission
